<template>
  <div v-on:click="toggleTheme" class="lightswitch">
  </div>
</template>

<style lang="stylus">
  .lightswitch
    width 32px
    height 32px
    padding 22px
    background center / 32px 32px no-repeat url('../assets/moon.png')
    cursor pointer
    z-index 101

  #app.theme-dark
    .lightswitch
      background center / 32px 32px no-repeat url('../assets/sun.png')
</style>

<script>
export default {
  methods: {
    toggleTheme () {
      this.$store.commit('toggleState')
    }
  }
}
</script>
